import { CircularProgress, Stack } from "@mui/material";
import React, { Component } from "react";
import Button from "./Button";

export default class ActionsContainer extends Component<any> {
  static defaultProps = {
    justifyContent: "end",
  };

  constructor(props: any) {
    super(props);
  }

  render() {
    const { disabled, onClose, actions, sx, justifyActions } = this.props;

    return (
      <Stack
        direction={{ xs: "column", sm: "column", md: "row-reverse" }}
        spacing={2}
        justifyContent={justifyActions}
        sx={{ position: "relative", width: "100%", ...sx }}
      >
        {disabled ? (
          <Button
            label="Close"
            variant="filled"
            autoFocus={true}
            onClick={onClose}
          />
        ) : (
          actions &&
          actions.map((action: any, key: any) => {
            const style: any = {
              display: action.visible !== false ? "flex" : "none",
              width: { xs: "100%", sm: "100%", md: "auto" },
            };

            if (action.floatRight) {
              style["position"] = "absolute";
              style["right"] = "0";
              style["marginRight"] = "0!important";
            }

            return (
              <Button
                key={key}
                form={action.form}
                type={action.type}
                className={action.id ? "klayo-button-" + action.id : null}
                label={action.label}
                variant={
                  action.acceptDanger
                    ? "filled-danger"
                    : action.variant
                      ? action.variant
                      : action.acceptWarning
                        ? "filled-warning"
                        : action.primary
                          ? "filled"
                          : "outlined"
                }
                //autoFocus={action.autoFocus || action.primary || false}
                onClick={action.onClick}
                disabled={action.disabled || false}
                sx={style}
                startIcon={
                  action.isLoading ? (
                    <CircularProgress
                      size={20}
                      {...(action.acceptDanger
                        ? {
                            color: "inherit",
                            style: {
                              color: "#fff",
                            },
                          }
                        : {
                            style: {
                              color: "#fff",
                            },
                          })}
                    />
                  ) : (
                    action.icon
                  )
                }
                endIcon={action.endIcon}
              />
            );
          })
        )}
      </Stack>
    );
  }
}
